var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2.75732H8C5.23858 2.75732 3 4.9959 3 7.75732V15.7573C3 18.5187 5.23858 20.7573 8 20.7573H16C18.7614 20.7573 21 18.5187 21 15.7573V7.75732C21 4.9959 18.7614 2.75732 16 2.75732ZM19.25 15.7573C19.2445 17.5499 17.7926 19.0018 16 19.0073H8C6.20735 19.0018 4.75549 17.5499 4.75 15.7573V7.75732C4.75549 5.96467 6.20735 4.51281 8 4.50732H16C17.7926 4.51281 19.2445 5.96467 19.25 7.75732V15.7573ZM16.75 8.00732C17.3023 8.00732 17.75 7.5596 17.75 7.00732C17.75 6.45504 17.3023 6.00732 16.75 6.00732C16.1977 6.00732 15.75 6.45504 15.75 7.00732C15.75 7.5596 16.1977 8.00732 16.75 8.00732ZM12 7.25732C9.51472 7.25732 7.5 9.27204 7.5 11.7573C7.5 14.2426 9.51472 16.2573 12 16.2573C14.4853 16.2573 16.5 14.2426 16.5 11.7573C16.5027 10.563 16.0294 9.41689 15.1849 8.5724C14.3404 7.72791 13.1943 7.25466 12 7.25732ZM9.25 11.7573C9.25 13.2761 10.4812 14.5073 12 14.5073C13.5188 14.5073 14.75 13.2761 14.75 11.7573C14.75 10.2385 13.5188 9.00732 12 9.00732C10.4812 9.00732 9.25 10.2385 9.25 11.7573Z",
    fill: "#1B1A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram-logo.b93654c823fd0ca158677be779863d5f.svg";
export { ForwardRef as ReactComponent };